import type { State } from '../../reducer';

export const isOpen = (state: State) => state.ui.add.isOpen;
